import {
  isNotOpenForSaleModal,
  ItemModalState,
} from "@/atoms/item/is-not-open-for-sale-modal";
import { itemPageState } from "@/atoms/item/item-page-state";
import { toastState } from "@/atoms/system/toast-state";
import { ButtonColor } from "@/common/enum/button-color";
import { itemService } from "@/services/item-service";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { Button, Modal } from "flowbite-react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { GrayExclamationCircleIcon } from "../icon/GrayExclamationCircleIcon";
import { Body16Regular } from "../typography/Body16Regular";

export const IsNotForSaleModal = () => {
  const [isOpenModal, setIsOpenModal] = useRecoilState<
    ItemModalState | undefined
  >(isNotOpenForSaleModal);
  const setItemPage = useSetRecoilState(itemPageState);
  const setToast = useSetRecoilState(toastState);

  const closeModal = () => {
    setIsOpenModal(undefined);
  };

  const handleSubmit = async () => {
    try {
      if (!isOpenModal) {
        return;
      }

      // 일괄 적용인 경우 (selectedIds가 있는 경우)
      if (isOpenModal.selectedIds && isOpenModal.selectedIds.length > 0) {
        const selectedIds = isOpenModal.selectedIds;

        // 모든 선택된 아이템에 대해 판매 시작 처리
        for (const itemId of selectedIds) {
          await itemService.manage(itemId, {
            isForSale: true,
          });
        }

        // 아이템 목록 갱신
        setItemPage((prev) => ({
          ...prev,
          contents: prev.contents.map((item) => {
            if (selectedIds.includes(item.id)) {
              return { ...item, isForSale: true };
            }
            return item;
          }),
        }));

        if (isOpenModal.onSuccess) {
          isOpenModal.onSuccess();
        }

        setToast({
          show: true,
          messages: [`${selectedIds.length}개 상품의 상태를 전환했습니다.`],
        });
      }
      // 단일 아이템 적용
      else {
        const manageResponse = await itemService.manage(isOpenModal.id, {
          isForSale: true,
        });
        if (!manageResponse.ok) {
          return;
        }
        const getByIdResponse = await itemService.getById({
          id: isOpenModal.id,
        });
        if (!getByIdResponse.ok) {
          return;
        }

        setItemPage((prev) => ({
          ...prev,
          contents: prev.contents.map((item) =>
            item.id === getByIdResponse.data.id ? getByIdResponse.data : item
          ),
        }));

        setToast({
          show: true,
          messages: ["상태를 전환했습니다."],
        });
      }

      closeModal();
    } catch (error) {
      console.log(error);
      setToast({
        show: true,
        messages: ["상태 전환에 실패했습니다."],
      });
    }
  };

  // 일괄 적용인지 확인
  const isBulkAction =
    isOpenModal?.selectedIds && isOpenModal?.selectedIds.length > 0;
  const itemCount = isBulkAction ? isOpenModal?.selectedIds?.length || 0 : 0;

  return (
    <Modal size="md" show={true} onClose={closeModal}>
      <Modal.Header className="pt-[10px] px-[10px] h-[36px] border-none"></Modal.Header>
      <Modal.Body className="p-0">
        <div className="flex flex-col items-center box-border py-[20px] gap-[20px]">
          <div className="w-[42px] h-[42px] flex items-center justify-center">
            <GrayExclamationCircleIcon size={35} />
          </div>
          <div className="flex flex-col items-center">
            <Body16Regular className="text-semantic-text-secondary">
              {isBulkAction
                ? `선택한 ${itemCount}개 상품을 판매 가능한 상태로 전환하시겠어요?`
                : "판매가 가능한 상태로 전환하시겠어요?"}
            </Body16Regular>
            <Body16Regular className="text-semantic-text-secondary">
              파트너들이 구매할 수 있게됩니다.
            </Body16Regular>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="pt-0 border-none">
        <div className="flex gap-[16px] items-center justify-center w-full">
          <Button
            size="sm"
            color={ButtonColor.TRANSPARENT_OUTLINE}
            onClick={closeModal}
          >
            취소하기
          </Button>
          <Button size="sm" color={ButtonColor.PRIMARY} onClick={handleSubmit}>
            전환하기
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
